import { useHasPermissions } from '@/lib/app/check-permissions.hook'

import { Textarea } from '@/components/lemmala-design-system/textarea/textarea'

type IrqFreeTextInputProps = {
  value?: string
  onChange: (content: string) => void
}

export const IrqFreeTextInput = ({ value, onChange }: IrqFreeTextInputProps) => {
  const hasIrqManagePermissions = useHasPermissions(['irq.manage'])

  return (
    <Textarea
      disabled={!hasIrqManagePermissions}
      placeholder='Type your answer'
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}
